import React from 'react';

interface JanusLogoMarkProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * JanusOS logo mark oficial da plataforma.
 * Apresenta o símbolo clássico de duas faces e a órbita de inteligência comercial.
 */
const JanusLogoMark: React.FC<JanusLogoMarkProps> = ({ size = 40, className, style }) => {
  return (
    <img
      src="/janusos-icon.svg"
      width={size}
      height={size}
      alt="JanusOS"
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        objectFit: 'contain',
        borderRadius: '50%',
        ...style,
      }}
      loading="eager"
    />
  );
};

export default JanusLogoMark;

